import React from "react";
import CompleteSTableHW from "./CompleteSTableHW";

const CompleteSTablePropsHW = ({ studentinfo }) => {
  return (
    <>
      {
        studentinfo &&
        studentinfo.length > 0 &&
        studentinfo?.map((obj) => (
          <CompleteSTableHW
            profile_pic={`${obj.profile_pic}`}
            Name={`${obj.Name}`}
            avatar_profile={`${obj?.avatar_profile}`}
            gender={`${obj?.gender}`}
            School_Email={`${obj.School_Email}`}
            Class={`${obj.Class}`}
            Division={`${obj.Division}`}
            Submited_Date={`${obj.Submited_Date}`}
            Status={`${obj.Status}`}
            Homework_id={`${obj.HomeWork_id}`}
            Student_id={`${obj.Student_id}`}
            Student_Marks={`${obj.Student_marks}`}
            total_marks={`${obj.total_marks}`}
            deadline={obj.deadline}
            submitted_on={obj.submitted_on}
          />
        ))}
    </>
  );
};

export default CompleteSTablePropsHW;
